const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const MENUS_ENDPOINTS = {
  BASE: `${API_URL}/menus`,
  SAVE: `${API_URL}/menus`,
  GET_CURRENT: `${API_URL}/menus/current`,
  /** Server-side engine (behind SERVER_MENU_GENERATION). Neither of these saves. */
  GENERATE: `${API_URL}/menus/generate`,
  SWAP: `${API_URL}/menus/swap`,
} as const;

export default MENUS_ENDPOINTS;
